import {ErrorHandler, Injectable, Injector} from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {LogService} from '../../shared/services/log.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  private toastr: ToastrService;

  constructor(injector: Injector, private log: LogService) {
    setTimeout(() => {
      this.toastr = injector.get( ToastrService );
    });
  }

  handleError(error: Error): void {

    if (error['errorsInHTML'] === undefined) {
      throw error;
    } else {
      this.toastr.error(
        error.message || 'Undefined client error'
      );
    }

    this.log.err('Error from global error handler', error, error);
  }
}
